module.exports = __webpack_public_path__ + "img/Documents.36970efe.svg";